import { type CurrencyDisplay, DEFAULT_CURRENCY, DEFAULT_CURRENCY_DISPLAY } from '@/ccpv2/types/constants';
import { currencies } from '@/utils/currencies';

type Formatters = Record<string, Intl.NumberFormat>;

const formatters = {} as Formatters;

const createFormatter = (currency: string, precision: number, display: Exclude<CurrencyDisplay, 'hidden'> = 'code') => {
  return currencies[currency].makeFormatter({
    maximumFractionDigits: precision,
    currencyDisplay: display,
  });
};

const getFormatter = (currency: string, precision: number, display: Exclude<CurrencyDisplay, 'hidden'>) => {
  if (!Object.prototype.hasOwnProperty.call(currencies, currency)) {
    throw Error(`Currency "${currency}" is not supported.`);
  }

  const key = `${currency}_${precision}_${display}`;

  if (!formatters[key as keyof typeof formatters]) {
    formatters[key] = createFormatter(currency, precision, display);
  }

  return formatters[key];
};

export const formatToCurrency = (
  value: number | null | undefined,
  currency: string | null | undefined = 'USD',
  precision: number | null | undefined = 0,
  display: CurrencyDisplay | undefined = 'code'
) => {
  const currencyCode = currency ?? DEFAULT_CURRENCY;
  const currencyDisplay = !display || display === 'hidden' ? DEFAULT_CURRENCY_DISPLAY : display;

  const res = value || value === 0 ? getFormatter(currencyCode, precision ?? 0, currencyDisplay).format(value) : null;

  if (res && display === 'hidden') {
    return res.replace(currencyCode, '').trim();
  }

  return res;
};
